// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HKTtBLwDyErB_o {
  height: 100%;
  margin-bottom: 12px;
  padding: 0 10px;
  overflow: hidden;
  background: transparent;
  color: var(--dynamic-text);
  font-size: 18px;
  font-weight: bold;
  line-height: 32px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.xYAK2xQEar7TWF {
  font-size: 16px;
}
.OrcHAUNWpMCCF1 .aT0m6qQxTMOyb8 {
  display: block;
  box-sizing: border-box;
}
.OrcHAUNWpMCCF1 .HKTtBLwDyErB_o {
  display: none;
}
.uXhW3KBBr1jUsJ:hover,
.uXhW3KBBr1jUsJ:focus {
  background-color: var(--dynamic-button-hovered);
  color: var(--dynamic-text);
  cursor: pointer;
}
.uXhW3KBBr1jUsJ:hover svg circle,
.uXhW3KBBr1jUsJ:focus svg circle {
  stroke: var(--dynamic-icon);
}
.hiRkezEUBG7ve6 {
  display: inline-flex;
  position: relative;
  max-width: 100%;
  height: 32px;
  margin-right: 4px;
  margin-bottom: 0;
  border-radius: 3px;
  line-height: 32px;
  white-space: nowrap;
  cursor: default;
}
.uPbVFGTNlV1fdg {
  overflow: hidden;
}
.UvKDpRw6bHbr02 .OrcHAUNWpMCCF1 .aT0m6qQxTMOyb8 {
  display: block;
}
.UvKDpRw6bHbr02 .OrcHAUNWpMCCF1 .HKTtBLwDyErB_o {
  display: none;
}
.aT0m6qQxTMOyb8 {
  display: none;
  height: 32px;
  margin: 0;
  padding: 0 10px;
  border: 0;
  background-color: var(--ds-background-input, #ffffff);
  font-size: 18px;
  font-weight: bold;
}
.aT0m6qQxTMOyb8:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardName": `HKTtBLwDyErB_o`,
	"boardNameSmall": `xYAK2xQEar7TWF`,
	"isEditing": `OrcHAUNWpMCCF1`,
	"boardNameInput": `aT0m6qQxTMOyb8`,
	"boardNameRenamable": `uXhW3KBBr1jUsJ`,
	"boardNameContainer": `hiRkezEUBG7ve6`,
	"boardNameContainerNoOverflow": `uPbVFGTNlV1fdg`,
	"boardNameContaner": `UvKDpRw6bHbr02`
};
export default ___CSS_LOADER_EXPORT___;
